<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickGoToVariablePay('Setup')">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickGoToVariablePay('Setup')">Variable Pay / Setup</span> / <span
            [style.color]="buttonColorName">Email Content</span></label>
      </div>
    </ion-col>
  </ion-row>
  
  <div class="modal-body p-20">
    <ion-row>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="input-form">
          <p>Subject:</p>
          <mat-form-field class="w-100 mat-height40 pl-15 mat-input-style">
            <input matInput [(ngModel)]="vpPolicyUrlSubject" placeholder="Congratulations on Your Variable Pay!">
          </mat-form-field>
        </div>
        <div *ngIf="vppolicySubjectCharValidation" class="fs-12 red mt-10">Subject length is greater than 255 characters</div>
      </ion-col>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <!-- <div class="btn-Group"> -->
          <button *ngIf="!isEditEmail" class="add_btn" (click)="onClickEdit()">Edit</button>
          <button class="mr-20 back_btn" *ngIf="isEditEmail" (click)="isDiscardChanges()">Discard Changes</button>
          <button *ngIf="isEditEmail" class="add_btn" (click)="saveVPPolicyFile()">Save</button>
        <!-- </div> -->
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="cardBox">
          <div class="email-content" *ngIf="!isEditEmail">
            <div [innerHTML]="vpletterContent1"></div>
          </div>
        
          <div *ngIf="flag=='edit'">
              <jodit-editor *ngIf="editorConfig" id="htmlDiv" [config]="editorConfig"
              [(ngModel)]="vpletterContent" ></jodit-editor> 
            <!-- <angular-editor [placeholder]="'Enter Email here...'" [config]="editorConfig"
            [(ngModel)]="vpletterContent"></angular-editor> -->
          </div>
 
        </div>
      </ion-col>
    </ion-row>
  </div>
  </ion-content>

  <!-- <h5>
              Dear Employee Name,
            </h5>
            <p>
              This is to inform you that your Variable Pay letter for this Month/Quarter..( As per set  frequency ) have been generated. <br/>
              You can access your letter by logging into the system.
            </p>
            <p>
              Please follow these steps to access your letter:-
              <br/>
              1.	Log in to the system using your credentials.<br/>
              2.	Navigate to the "Variable Pay" module.<br/>
              3.	You will find your Variable Pay letter under the "Variable Pay Tab."<br/>
            </p>
            <p>
              This Variable Pay  is a reflection of your hard work and commitment to our success. Should you have any questions or need assistance, please contact [HR/IT support].
            </p>
            <p>
              Thank you for your continued efforts and dedication
            </p>
            <h5>
              Best regards,
            </h5>
            <h5>
              [Your Company Name]
            </h5> -->

   